import React, { useMemo } from 'react';
import { VALUE_CARD_PALETTES } from '../Widgets/ValueCardWidget';
import { Input, Select } from '@/components/ui';
import { Form, FormField } from '@/components/business';
import { Widget } from './Widget';

export function NewValueWidgetGeneral ({ form }) {
    const data = form.watch();

    const paletteOptions = useMemo(() => VALUE_CARD_PALETTES.map(palette => ({
        label: palette.capitalize(),
        value: palette
    })), []);

    return (
        <div className="tw-flex tw-gap-6">
            <div className="tw-flex-1">
                <Form form={form}>
                    <FormField name="title" label={i18next.t('glossary.title').capitalize()}
                        render={({ field }) => (
                            <Input {...field} placeholder={i18next.t('glossary.title').capitalize()} />
                        )}
                    />
                    <FormField name="subtitle" label={i18next.t('glossary.subtitle').capitalize()}
                        render={({ field }) => (
                            <Input {...field} placeholder={i18next.t('glossary.subtitle').capitalize()} />
                        )}
                    />
                    <FormField name="legend" label={i18next.t('common.legend').capitalize()}
                        render={({ field }) => (
                            <Input {...field} placeholder={i18next.t('common.legend').capitalize()} />
                        )}
                    />
                    <FormField name="graphical.palette" label={i18next.t('glossary.palette').capitalize()}
                        render={({ field }) => (
                            <Select
                                onChange={selectedOption => field.onChange(selectedOption?.value ?? '')}
                                options={paletteOptions}
                                placeholder={i18next.t('dashboard.custom_dashboard.select_a_palette')}
                                sort={null}
                                value={paletteOptions.find(option => option.value === field.value) ?? null}
                            />
                        )}
                    />
                </Form>
            </div>
            <div className="tw-w-widget-preview tw-h-widget-preview tw-flex-shrink-0">
                <Widget widget={data}/>
            </div>
        </div>
    );
}
